import { useEffect, useState } from "react"
import Select from 'react-select'
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { useAuthState } from "../../Helper/Context"
import { EmployeeNameDDLAPI } from "../../Redux/DDLSlice"

export const EmployeeCommanDDL = (props) => {

    const { EmployeeNameID, setEmployeeNameID, Flag, data, IsPost, Language, StarMark, DesignationNameID, ApiFlag, EmployeeFlag } = props

    const { t } = useTranslation()

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    useEffect(() => {
        const data = {
            M_DesignationID: DesignationNameID.ID,
            UserID: UserID,
            Flag: ApiFlag,
            lanaguage: Language.Label,
            token: token
        }
        { Language.Label != '' && dispatch(EmployeeNameDDLAPI({ data })) }
    }, [IsPost, Language.Label, DesignationNameID.ID])

    const { DDLData } = useSelector(state => state.EmployeeNameDDLData)

    useEffect(() => {
        handleDDL()
    }, [DDLData])

    const handleDDL = () => {
        if (DDLData && DDLData.table && DDLData.table.length > 0) {
            let list = DDLData.table.map((item, index) => ({
                value: item.m_EmployeeID,
                label: item.employeeName,
                table_M_UserID: item.table_M_UserID,
            }))

            {
                EmployeeFlag == "PathakWiseEmp" ?
                    setEmployeeNameID({
                        DDL: list,
                        ID: Flag == 'Update' ? data?.employeeID : 0,
                        Label: Flag == 'Update' ? data?.employeeName : "Select...",
                        table_M_UserID: 0,
                    })
                    :
                    setEmployeeNameID({
                        DDL: list,
                        ID: Flag == 'Update' ? data?.m_EmployeeID : 0,
                        Label: Flag == 'Update' ? data?.employeeName : "Select...",
                        table_M_UserID: 0,
                    })

            }


        }
        else {
            setEmployeeNameID({
                DDL: [],
                ID: 0,
                Label: "Select...",
                table_M_UserID: 0,
            })
        }
    }
    return (
        <div className="form-group">
            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.EmployeeName')} </label>
            <Select
                id='WardNameID'
                isClearable={false}
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={130}
                value={{ value: EmployeeNameID.ID, label: EmployeeNameID.Label, table_M_UserID: EmployeeNameID.table_M_UserID }}
                onChange={(e) => {
                    e ?
                        setEmployeeNameID({ ...EmployeeNameID, ID: e.value, Label: e.label, table_M_UserID: e.table_M_UserID })
                        :
                        setEmployeeNameID({ ...EmployeeNameID, ID: 0, Label: "Select...", table_M_UserID: '' })

                }}
                options={EmployeeNameID.DDL}
            />
        </div>
    )
}